/** Shared wording used on more than one screen. */

export const FUNDS_EXPLAINER =
  "Activity funds are earmarked for TMA music activities (trips, camps, TRSD lessons). They can't be withdrawn as cash.";

export const IN_APP_BROWSER_HINT =
  'You\'re viewing TMA inside another app (like Facebook). To install it and get notifications, open this page in Safari or Chrome: tap the ••• menu, then "Open in browser".';
